import React from 'react';
import { useTranslations } from '../../../locales/useTranslations';

const MailServerFaq = () => {
  const { t } = useTranslations();
  const faqs = [1, 2, 3, 4, 5, 6, 7, 8].map((n) => ({
    q: t(`managedServices_mailServer_faq_q${n}`),
    a: t(`managedServices_mailServer_faq_a${n}`),
  }));

  return (
    <section className="ms-faq">
      <div className="container">
        <div className="ms-faq__inner">
          <h2 className="ms-faq__title">{t('managedServices_mailServer_faq_title')}</h2>
          <div className="ms-faq__accordion native-accordion">
            {faqs.map((faq, index) => (
              <details key={index} open={index === 0}>
                <summary>{faq.q}</summary>
                <div className="accordion-content">
                  <p>{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MailServerFaq;
